import { createValidator, maxLength, required } from 'util/validation'

import { RetificacaoAtendimentoModel } from './model-retificacaoAtendimento'

export const validateRetificacaoAtendimentoModal = createValidator<RetificacaoAtendimentoModel>({
  tipo: [required],
  justificativa: [required, maxLength(500)],
})
